<template>
  <ul class="breadcrumbs"
      :class="{
        'm0' : currentProduct === null
       }">
    <li>
      <router-link :to="{name: 'Home'}">
        <img class="home-icon" src="@/assets/images/icons/Home_icon.svg" alt="">
      </router-link>
    </li>
    <li>
      <component :is="currentProduct != null ? 'router-link' : 'div'"
                 :to="{name: 'ProductsView',
                 params: {productCategory: currentCategory,}}">
        {{t('breadcrump.' + currentCategory + '.title')}}
      </component>
    </li>

    <li v-if="currentProduct">
      <span style="color: #9572A4;"> > </span>
      {{currentProduct}}
    </li>
  </ul>
</template>
<script>

import { useI18n } from 'vue-i18n';

export default {
  name: 'TheBreadcrumb',
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  props: {
    currentCategory: {
      type: String,
      default: null,
    },
    currentProduct: {
      type: String,
      default: null,
    },
  },
};
</script>
